import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from './../../_services/index';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  providers: [AuthenticationService]

})
export class ChangePasswordComponent implements OnInit {

  ErrorMassage: any;
  resetForm: any;
  public errorFlag = false;
  loading = false;
  current_password: string;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private resetpasswordservice: AuthenticationService
  ) { }

  ngOnInit() {
    
    this.validateResetPasswordForm();
    //console.log(typeof this.token);
    
  }
  validateResetPasswordForm() {
    this.resetForm = this.formBuilder.group({
      'current_password': ['', [Validators.required, ValidationService.passwordValidator]],
      'new_password': ['', [Validators.required, ValidationService.passwordValidator]],
      'confirm_password': ['', [Validators.required, ValidationService.passwordValidator]]
    });
  }

  resetPassword() {
    this.loading = true;
    this.resetpasswordservice.changePassword(
      this.resetForm.value.new_password,
      this.resetForm.value.confirm_password,
      this.resetForm.value.current_password
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.ErrorMassage = response.message;
          this.errorFlag = false;
          this.loading = false;
          this.current_password = this.resetForm.value.current_password;
          this.resetForm.reset({
            'current_password': '',
            'new_password': '',
            'confirm_password': ''
          });
        }
      },
      error => {
        this.loading = false;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.ErrorMassage = errordata.message;
          this.errorFlag = true;
        }

      }
    );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/change-password/change-password.component.ts